
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/ban-types */
import { Options, Vue } from "vue-class-component";
import Title from "@/app/ui/components/data-wrapper/title.vue";
import CustomDropdown from "@/app/ui/components/custom-dropdown/index.vue";
import RadioButton from "primevue/radiobutton";
import Checkbox from "primevue/checkbox";
import debounce from "lodash/debounce";
import { MessagingServiceConfigurationController } from "@/app/ui/controllers/MessagingServiceConfigurationController";
import { ProductController } from "@/app/ui/controllers/ProductController";
import {
  APPLIED_TO_MESSAGE_OPTIONS,
  MESSAGE_TYPE_OPTIONS,
  EVENT_STATUS_OPTIONS,
  PACKAGE_TYPE_OPTIONS
} from "@/app/ui/views/messaging-service-configuration/MessagingServiceConfigurationUtils";
import { PodDexController } from "@/app/ui/controllers/PodDexController";
import { PartnerController } from "@/app/ui/controllers/PartnerController";
import { ClientManagementController } from "@/app/ui/controllers/ClientManagementController";
import { LocationController } from "@/app/ui/controllers/LocationController";
import { ReasonListDex } from "@/data/payload/api/PodDexRequest";
import { OptionsClass } from "@/domain/entities/MainApp";
import { ReasonData } from "@/domain/entities/PodDex";
import SelectHours from "../components/select-hours.vue";
import { MessageConfVariables } from "@/domain/entities/MessagingServiceConfiguration";

@Options({
  components: {
    Title,
    RadioButton,
    Checkbox,
    SelectHours,
    CustomDropdown
  }
})
export default class MessagingServiceConfigurationFormCriteriaSection extends Vue {
  mounted() {
    if (this.isEditPage) {
      this.tempData = JSON.parse(
        JSON.stringify({
          posPartners: this.form.posPartners,
          posPartnersExclude: this.form.posPartnersExclude,
          clientBranches: this.form.clientBranches,
          clientBranchesExclude: this.form.clientBranchesExclude
        })
      );
    }
  }
  get isFormTypeEdit() {
    return this.$route.meta.formType === "edit";
  }
  get form() {
    return MessagingServiceConfigurationController.messageServiceForm;
  }
  get showSelectPOS() {
    return this.form.appliedTo.includes("pos");
  }
  get showSelectClientBranch() {
    return this.form.appliedTo.includes("client");
  }

  tempData: any = {};

  get isEditPage() {
    return this.$route.path?.includes("edit");
  }
  onCheckSTTCreatedFor(val: string) {
    if (!this.showSelectPOS) {
      this.form.posPartners = [];
      this.form.posPartnersExclude = [];
      return;
    }
    if (!this.showSelectClientBranch) {
      this.form.clientBranches = [];
      this.form.clientBranchesExclude = [];
      return;
    }
    if (this.isEditPage) {
      if (this.showSelectPOS && val === "pos") {
        this.form.posPartners = JSON.parse(
          JSON.stringify(this.tempData.posPartners)
        );
        this.form.posPartnersExclude = JSON.parse(
          JSON.stringify(this.tempData.posPartnersExclude)
        );
        return;
      } else {
        this.form.clientBranches = JSON.parse(
          JSON.stringify(this.tempData.clientBranches)
        );
        this.form.clientBranchesExclude = JSON.parse(
          JSON.stringify(this.tempData.clientBranchesExclude)
        );
      }
    }
  }

  // status berita
  get eventStatusOptions() {
    return EVENT_STATUS_OPTIONS;
  }
  eventStatusSelect = false;
  onChangeEventStatus(items: any) {
    const { value: val } = items
    this.form.eventStatus = val;

    if (val === "CODREJ") {
      this.form.packageType = "cod";
    }

    if (val === "DEX") {
      this.form.msgConfAttemptDex = 1;
    }

    this.form.reasons = [];

    if (!this.isFormTypeEdit) {
      this.form.msgConfCountSla = "";
      this.form.msgConfCronHours = "";

      if (this.form.isOverSla) {
        this.form.msgConfCountSla = "1"; // default 1
      }
    }
  }

  // tipe pesan
  get messageTypeOptions() {
    return MESSAGE_TYPE_OPTIONS;
  }

  messageTypeSelect = false;
  onSelectMessageType(items: any) {
    const { value: val }  = items;
    if (val !== "wa_premium") {
      this.form.templateName = "";
    }

    if (!this.isFormTypeEdit) {
      this.form.msgConfMeta = [new MessageConfVariables()];
    }

    this.form.messageType = val
  }

  //tipe layanan
  serviceTypeSelect = false;
  onSelectServiceType(items: any) {
    const { value } = items
    this.form.packageType = value
  }

  // reason
  get displayReasonField(): boolean {
    return !!this.form.eventStatus?.toLowerCase().match(/cnx|dex|codrej|rejected/);
  }
  async fetchReason() {
    await PodDexController.getReasonList(
      new ReasonListDex({
        statusCode: this.form.eventStatus,
        reasonStatus: "active"
      })
    );
  }
  get reasonData(): OptionsClass[] {
    const data = PodDexController.reasonList.map(
      (key: ReasonData) =>
        new OptionsClass({
          name: key.reasonDescription,
          value: key.reasonDescription
        })
    );

    return [
      new OptionsClass({
        name: "All Reason Status",
        value: "All"
      }),
      ...data
    ];
  }
  get loadingReason() {
    return PodDexController.isLoadingDex;
  }

  // tipe paket
  get packageTypeOptions() {
    return PACKAGE_TYPE_OPTIONS;
  }

  // dibuat untuk
  get appliedToOptions() {
    return APPLIED_TO_MESSAGE_OPTIONS;
  }

  // jenis pengiriman
  listProduct: any = [];
  listProductRes: any = [];
  loadingProduct: Boolean = false;
  async fetchProducts() {
    this.loadingProduct = true
    this.listProductRes = await ProductController.fetchProductApi({
      page: 1,
      limit: 99,
      status: "active",
      isNoLimit: true
    });
    this.listProduct = this.listProductRes
    this.loadingProduct = false
  }
  get productOptions() {
    return this.listProduct.map((e: any) => (e.name));
  }
  filterProducts = debounce(async (search: string) => {
    if (search.length < 3 && search.length > 0) {
      return;
    }
    this.loadingProduct = true
    this.listProduct = this.listProductRes.filter((product: any) => product.name.toLowerCase().includes(search.toLocaleLowerCase()))
    this.loadingProduct = false
  }, 250);

  // pos
  listPOS: any = [];
  isLoadingPOS = false;
  get isChooseAllPOS() {
    const allItemIndex = this.form.posPartners.findIndex((item: any) => {
      return item.value === "All";
    });
    return allItemIndex > -1;
  }
  async fetchPOS(search: string) {
    this.isLoadingPOS = true;
    this.listPOS = await PartnerController.fetchPartnerApi({
      page: 1,
      limit: 10,
      search: search,
      type: "pos",
      cityCode:
        this.isChooseAllCityOrigin || this.form.originCities.length === 0
          ? "ALL"
          : this.form.originCities
            .map((city: any) => {
              return city.value;
            })
            .join(","),
      cityCodeExclude: this.form.originCitiesExclude
        .map((city: any) => {
          return city.value;
        })
        .join(",")
    });
    this.isLoadingPOS = false;
  }
  filterPOS = debounce(async (search: string) => {
    await this.fetchPOS(search);
  }, 250);
  get posOptions() {
    if (this.posExcludeOptions.length === 0) {
      return [];
    }
    return [
      {
        name: "All POS",
        value: "All"
      },
      ...this.posExcludeOptions
    ];
  }
  get posExcludeOptions() {
    return this.listPOS.map((pos: any) => {
      return {
        name: pos.name,
        value: pos.id
      };
    });
  }
  onChangePOS() {
    this.form.posPartnersExclude = [];
  }

  // client branch
  isLoadingClientBranch = false;
  listClientBranch: any = [];
  get isChooseAllClientBranch() {
    const allItemIndex = this.form.clientBranches.findIndex((item: any) => {
      return item.value === "All";
    });
    return allItemIndex > -1;
  }
  get clientBranchExcludeOptions() {
    return this.listClientBranch.map((clientBranch: any) => {
      return {
        name: clientBranch.clientCompanyName,
        value: clientBranch.clientId
      };
    });
  }
  get clientBranchOptions() {
    if (this.clientBranchExcludeOptions.length === 0) {
      return [];
    }
    return [
      {
        name: "All Client Cabang",
        value: "All"
      },
      ...this.clientBranchExcludeOptions
    ];
  }

  async fetchClient(clientType: string, search: string) {
    return await ClientManagementController.fetchClientManagementApi(
      {
        page: 1,
        limit: 10,
        search,
        cityCode:
          this.isChooseAllCityOrigin || this.form.originCities.length === 0
            ? "ALL"
            : this.form.originCities
              .map((city: any) => {
                return city.value;
              })
              .join(","),
        cityCodeExclude: this.form.originCitiesExclude
          .map((city: any) => {
            return city.value;
          })
          .join(","),
        type: clientType
      }
    );
  }
  async fetchClientBranch(search: string) {
    this.isLoadingClientBranch = true;
    this.listClientBranch = await this.fetchClient("branch", search)
    this.isLoadingClientBranch = false;
  }
  // client search
  filterClientBranch = debounce(async (search: string) => {
    if (search.length < 3 && search.length > 0) {
      return;
    }
    await this.fetchClientBranch(search);
  }, 250);
  onChangeClientBranch() {
    this.form.clientBranchesExclude = [];
    this.form.clientParent = [];
    this.form.clientParentExclude = [];
  }

  //client parent
  isLoadingClientParent = false;
  listClientParent: any = [];
  get clientParentExcludeOptions() {
    return this.listClientParent.map((clientParent: any) => {
      return {
        name: clientParent.clientCompanyName,
        value: clientParent.clientId
      };
    });
  }
  get clientParentOptions() {
    if (this.clientParentExcludeOptions.length === 0) {
      return [];
    }
    return [
      ...this.clientParentExcludeOptions
    ];
  }
  async fetchClientParent(search: string) {
    this.isLoadingClientParent = true;
    this.listClientParent = await this.fetchClient("parent", search);
    this.isLoadingClientParent = false;
  }
  filterClientParent = debounce(async (search: string) => {
    if (search.length < 3 && search.length > 0) {
      return;
    }
    await this.fetchClientParent(search);
  }, 250);
  onChangeClientParent() {
    this.form.clientParentExclude = [];
  }

  //star-end-date
  get invalidStartDate() {
    return (
      this.form.startDate.getTime() > this.form.endDate.getTime() ||
      this.form.startDate.getTime() === this.form.endDate.getTime()
    );
  }
  get invalidEndDate() {
    return (
      this.form.endDate.getTime() < this.form.startDate.getTime() ||
      this.form.endDate.getTime() === this.form.startDate.getTime()
    );
  }
  get minimumDateForEndDate() {
    const date =
      this.form.startDate.getTime() >= new Date().getTime()
        ? this.form.startDate
        : new Date();
    return new Date(new Date().setDate(date.getDate() + 1));
  }

  // origin city
  fetchCity(search: string) {
    LocationController.getCityList({
      search: search,
      status: "active",
      page: 1,
      limit: 10
    });
  }
  filterCity = debounce((search: string) => {
    if (search.length > 2 || !search) this.fetchCity(search);
  }, 250);
  get cityExcludeOptions() {
    return LocationController.cityData.cityData.map(e => ({
      id: e.id,
      name: `${e.code} - ${e.name}`,
      value: `${e.code}`
    }));
  }
  get cityOptions() {
    return [
      {
        name: "All Origin City",
        value: "All"
      },
      ...this.cityExcludeOptions
    ];
  }
  get isLoadingCity() {
    return LocationController.isLoading;
  }
  get isChooseAllCityOrigin() {
    const allItemIndex = this.form.originCities.findIndex((item: any) => {
      return item.value === "All";
    });
    return allItemIndex > -1;
  }
  onChangeOriginCity() {
    this.form.originCitiesExclude = [];
  }

  // destination city
  fetchDestination(search: string) {
    LocationController.getCityList({
      search: search,
      status: "active",
      page: 1,
      limit: 10
    });
  }

  filterDestinationCity = debounce((search: string) => {
    if (search.length > 2 || !search) this.fetchDestination(search);
  }, 250);

  get cityDestOptions() {
    return [
      {
        name: "All Destination City",
        value: "All"
      },
      ...this.cityExcludeOptions
    ];
  }

  get isChooseAllCityDestination() {
    const allItemIndex = this.form.destinationCities.findIndex((item: any) => {
      return item.value === "All";
    });
    return allItemIndex > -1;
  }

  onChangeDestinationCity() {
    this.form.destinationCitiesExclude = [];
  }

  formatNumber(value: string) {
    const prefix = /[\D]+/g;
    return value.replace(prefix, "");
  }
}
